Object.defineProperty(exports,"__esModule",{value:true});var _reactDom=require('react-dom');exports.default=_reactDom.findDOMNode;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/modules/findNodeHandle/index.js
 ** module id = 96
 ** module chunks = 0
 **/